import kaplay from "kaplay";
import "kaplay/global"; // uncomment if you want to use without the  prefix


kaplay({
    //global: false,
    background: [200,200,255],
    width: 1280,
    height: 720,
    letterbox: true,
    //debug: false, // TODO: Uncomment when publishing
});

loadSprite("player", "sprites/player.png");
loadSprite("turtle", "sprites/turtle.png");
loadSprite("sword", "sprites/sword.png");
loadSprite("fireball", "sprites/fireball.png");

loadSound("swing", "sounds/sword.wav");
loadSound("hit", "sounds/hit.wav")
loadSound("hurt", "sounds/enemyHurt.wav");
loadSound("bgm", "sounds/Mercury.wav");
loadSound("fireball", "sounds/fireball.wav");

let musicPlay = null;

scene("game", () => {

// so the music doesn't overlap itself
if (!musicPlay) {
    musicPlay = play("bgm", { loop: true, volume: 0.3 });
}


const PLAYER_SPEED = 300;

let gameTime = 0
let killCount = 0;

onUpdate(() => { 
    gameTime += dt();
})

loop(1, () => {
    const numEnemiesToSpawn = Math.floor(1 + gameTime / 5);
    const hp = 1 + Math.floor(gameTime / 15);
    for (let i = 0; i < numEnemiesToSpawn; i++) {
        spawnEnemy(hp);
    }
});

const player = add([
    //rect(16, 16),
    sprite("player"),
    scale(4),
    pos(center()),
    //color(0, 0, 0),
    health(10),
    area(),
    anchor("center"),
    "player",
]);

let PLAYER_ATK = 5

let stats = { ATK: 5, INT: 5, SPD: 5 };
let buffs = { swordSpin: 0, fireballSpin: 0};

onUpdate(() => {
    if (buffs.swordSpin > 0)
        buffs.swordSpin -= dt();
    if (buffs.fireballSpin > 0)
        buffs.fireballSpin -= dt();
    
});

function spawnPowerup(p) {
    const type = choose(["swordSpin", "fireballSpin"]);
    const col = type == "swordSpin" ? rgb(255, 255, 100) : rgb(255, 100, 100);
    const powerup = add([
        rect(24, 24),
        pos(p),
        color(col),
        area(),
        anchor("center"),
        rotate(0),
        "powerup",
        { powerupType: type, life: 12},
    ])

    powerup.onUpdate(() => {
        powerup.angle += 360 * dt();
        powerup.life -= dt();
        if (powerup.life <= 0)
            destroy(powerup);
        
    })
    powerup.onCollide("player", () => {
        buffs[powerup.powerupType] = 5 // 5 seconds
        shake(10);
        play("hit", { volume: 0.7 });
        destroy(powerup);
    })
}

function rollStats() {
    stats.ATK = randi(1,11);
    stats.INT = randi(1,11);
    if (stats.ATK < 6 && stats.INT < 6) {
        if (stats.ATK >= stats.INT)
            stats.ATK = 6
        else
            stats.INT = 6
    }
}

rollStats();

loop(15, () => {
    rollStats();
    shake(15);
    const flash = add([
        text("SPIN!", { size: 96 }),
        pos(center()),
        anchor("center"),
        color(255, 220, 70),
    ]);
    wait(1.0, () => destroy(flash));
});

player.onDeath(() => go("gameover"));

const health_bar = add([
    text("HEALTH: "+ player.hp(), { size: 32}),
    pos(25, 25),
])

let stat_ATK = add([
    text("ATK: 5", { size: 32}),
    pos(25, 60),
])

let stat_INT = add([
    text("INT: 5", { size: 32}),
    pos(25, 90),
])

let stat_SPD = add([
    text("SPD: 5", { size: 32}),
    pos(25, 120),
])


const score_label = add([
    text("KILLS: 0", { size:32 }),
    pos(width() - 25, 25),
    anchor("topright"),
]);

// const enemy = add([
//     rect(20,20),
//     pos(0,0),
//     { speed: 150, isAngry: true},
//     area(),
// ]);

function spawnEnemy(hp) {
    const e = add([
    //rect(20,20),
    sprite("turtle"),
    scale(2),
    pos(rand(vec2(0, 0), vec2(width(), height()))),
    health(hp),
    { speed: 150, isAngry: true},
    area(),
    "enemy",
    ]);
    e.onUpdate(() => {
        let path = player.pos.sub(e.pos).unit()
        // console.log(path)
        e.move(path.scale(e.speed))
        if (e.hp() <= 0){
            killCount++;
            if (chance(0.12)) {
                spawnPowerup(e.pos);
            }
            destroy(e);
        }
    });


    e.onCollide("player", (player) => {player.hurt(1), destroy(e), play("hurt", {volume: 0.5})})
    return e;
};

spawnEnemy(2)
spawnEnemy(2)

loop(3, () => spawnEnemy(2));

//loop(5, spawnEnemy(1));

//loop
// let enemy3 = spawnEnemy(4)
// let enemy4 = spawnEnemy(4)

// console.log(enemy1.health)

onUpdate(() => {
    if (isKeyDown("w"))
        player.move(0, -PLAYER_SPEED)
     if (isKeyDown("a"))
        player.move(-PLAYER_SPEED, 0)
     if (isKeyDown("s"))
        player.move(0, PLAYER_SPEED)
     if (isKeyDown("d"))
        player.move(PLAYER_SPEED, 0)

    health_bar.text = "HEALTH: " + player.hp();
    stat_ATK.text = "ATK: " + stats.ATK + (stats.ATK >= 6 ? " SWORD!" : "");
    stat_INT.text = "INT: " + stats.INT + (stats.INT >= 6 ? " FIRE!" : "");
    stat_SPD.text = "SPD: " + stats.SPD;
    score_label.text = "KILLS: " + killCount;

    let playerVector = mousePos().sub(player.pos)
    //console.log(playerVector.x)
    player.angle = playerVector.angle()
    player.pos.x = (clamp(player.pos.x, 0, width() - player.width))
    player.pos.y = (clamp(player.pos.y, 0, height()- player.height))

});


//onClick(() => addKaboom(mousePos()));

let spinSwordObj = null;
let spinSwordAngle = 0;

onUpdate(() => {
    if (buffs.swordSpin > 0) {
        if (!spinSwordObj) {
            spinSwordObj = add([
                sprite("sword"),
                scale(6),
                pos(player.pos),
                area(),
                anchor("left"),
                rotate(0),
                "sword",
                { hitCooldown: {} },
            ])
            spinSwordObj.onCollide("enemy", (enemy) => {
                const now = time();
                if (spinSwordObj.hitCooldown[enemy.id] && now - spinSwordObj.hitCooldown[enemy.id] < 0.3)
                    return;
                spinSwordObj.hitCooldown[enemy.id] = now;
                enemy.hurt(Math.max(stats.ATK, 4));
                play("hit", { volume: 0.3});
            });
        }
        spinSwordAngle += 720 * dt();
        spinSwordObj.angle = spinSwordAngle;
        spinSwordObj.pos = player.pos;
    }
    else if (spinSwordObj) {
        destroy(spinSwordObj);
        spinSwordObj = null;
    }
});

function swingSword() {
    if (stats.ATK < 6)
        return;

    play("swing", { volume: 0.5 });
    const startAngle = player.angle - 45;
    const swingArc = 90;

    const sword = add([
        //rect(60, 20),
        sprite("sword"),
        scale(6),
        pos(player.pos),
        //color(0, 0, 0),
        //health(5),
        area(),
        //rotate(Vec2.fromAngle(player.angle)),
        rotate(player.angle),
        anchor("left"),
        "sword",
        { life: 0.15, maxLife: 0.15, startAngle: startAngle },
    ]);

    sword.onUpdate(() => {
        sword.life -= dt();
        const progress = 1 - (sword.life / sword.maxLife);
        sword.angle = sword.startAngle + swingArc * progress;
        sword.pos = player.pos;

        if (sword.life <= 0)
            destroy(sword);
    })
    
    sword.onCollide("enemy", (enemy) => { enemy.hurt(stats.ATK), play("hit", { volume: 0.4 })/*minus x amount of hp from enemy*/;})

}

let fireballTimer = 0;

onUpdate(() => {
    if (stats.INT < 6) return;
    fireballTimer -= dt();
    if (fireballTimer <= 0) {
        fireballTimer = Math.max(0.1, 0.8 - stats.SPD * 0.06);
        spawnFireball();
    }
});

let fireballSpinTimer = 0;

onUpdate(() => {
    if (buffs.fireballSpin > 0) {
        fireballSpinTimer -= dt();
        if (fireballSpinTimer <= 0) {
            fireballSpinTimer = 0.08;

            const ang = rand(0,360);
            const dir = Vec2.fromAngle(ang);
            const fb = add([
                sprite("fireball"),
                scale(2),
                pos(player.pos),
                area(),
                anchor("center"),
                { vel: dir.scale(500), life: 2.5 },
                "fireball",
            ]);
            fb.onUpdate(() => {
                fb.move(fb.vel);
                fb.life -= dt();
                if (fb.life <= 0) {
                    destroy(fb);
                }
            });
            fb.onCollide("enemy", (enemy) => {
                enemy.hurt(Math.max(stats.INT, 4));
                destroy(fb);
            })
        }
    }
});

function spawnFireball() {
    const dir = mousePos().sub(player.pos).unit();
    const fireball = add([
        //circle(8),
        sprite("fireball"),
        scale(2),
        pos(player.pos),
        //color(255, 135, 40),
        area(),
        anchor("center"),
        { vel: dir.scale(500 + stats.SPD * 30), life: 2},
        "fireball",
    ]);
    fireball.onUpdate(() => {
        fireball.move(fireball.vel);
        fireball.life -= dt();
        if (fireball.life <= 0)
            destroy(fireball);
    });
    play("fireball", { volume: 0.5});

    fireball.onCollide("enemy", (enemy) => {
        enemy.hurt(stats.INT);
        destroy(fireball);
    });
}

onMousePress(swingSword)

});

scene("gameover", () => {
    add([
        text("you died.", { size: 128}),
        pos(center()),
        anchor("center"),
        "gameover",
    ]);
    add([
        text("click to retry", { size: 32}),
        pos(100,200)
    ])
    onMousePress(() => go("game"));
})



go("game")